import React from 'react'

import styles from './styles.module.scss'

const SupportBeyondSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.columns}>
          <div className={styles.imageColumn}>
            <img
              src="/veteran-services/jefferson-memorial.jpg"
              alt="Jefferson Memorial framed by cherry blossoms"
              className={styles.image}
            />
          </div>

          <div className={styles.copyColumn}>
            <h3 className={styles.heading}>Support Beyond the Service</h3>
            <p className={styles.body}>
              For out-of-town families, we can help arrange a meaningful &ldquo;final ride&rdquo;
              through Washington, DC, passing memorials, monuments, and enduring symbols of the
              nation your loved one pledged to protect and defend. For many, it becomes one final
              gesture of gratitude, honor, and love before arriving at Arlington National Cemetery.
            </p>
            <p className={styles.body}>
              We can also assist with local accommodations and coordinate transportation for the day
              of the service, so you can focus on being together while we handle the details.
            </p>
            <p className={styles.body}>
              Located near National Harbor and Washington DC, families visiting from out of town
              often appreciate the opportunity to spend meaningful time together beyond the service
              itself. Our team is happy to recommend nearby accommodations, dining, transportation,
              and local experiences during your stay.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SupportBeyondSection
